import * as yup from 'yup'

export const focRmaSchema = yup.object().shape({
  reason: yup.string().required('Reason is required'),
  condition: yup.string().required('Condition is required'),
})

export const createFocOrderFormSchema = yup
  .object()
  .shape({
    orderType: yup.string().trim().required('Order Type is required'),
    locationCode: yup.string().trim().required('Location Code is required'),

    appliesToMagentoOrderNo: yup
      .string()
      .trim()
      .required('Magento Order No is required'),

    barcodeNo: yup
      .string()
      .trim()
      .required('Barcode No is required')
      .matches(/^[0-9]+$/, 'Barcode No must contain only numbers'),

    quantity: yup
      .number()
      .typeError('Quantity must be a number')
      .required('Quantity is required')
      .min(1, 'Quantity must be greater than or equal to 1')
      .max(1000, 'Quantity must be greater less or equal to 1000'),

    lineAmountExclVAT: yup
      .number()
      .typeError('Line Amount (Excl. VAT) must be a number')
      .required('Line Amount (Excl. VAT) is required')
      .min(0, 'Line Amount (Excl. VAT) must be greater than or equal to 0'),

    vatAmount: yup
      .number()
      .typeError('VAT Amount must be a number')
      .required('VAT Amount is required')
      .min(0, 'VAT Amount must be greater than or equal to 0'),

    lineAmountInclVAT: yup
      .number()
      .typeError('Line Amount (Incl. VAT) must be a number')
      .required('Line Amount (Incl. VAT) is required')
      .min(0, 'Line Amount (Incl. VAT) must be greater than or equal to 0'),
  })
  .required()
